import { defineComponent as E, computed as a, createElementBlock as c, openBlock as i, normalizeClass as m, createElementVNode as p, createBlock as b, createCommentVNode as v, unref as u, Fragment as B, renderList as D, resolveDynamicComponent as F, toRaw as I, toDisplayString as g, withCtx as M, createTextVNode as T } from "vue";
import { sizeNameToSize as V } from "@ds/components/Icon";
import { RevLink as O } from "@ds/components/Link";
import { usePropsValidation as P } from "../../composables/usePropsValidation.js";
import H from "../../icons/generated/IconStarFilled.vue2.js";
import q from "../../icons/generated/IconStarHalf.vue2.js";
import W from "../../icons/generated/IconStarOutlined.vue2.js";
import { useLocale as X, useI18n as j } from "@ds/plugin";
import G from "../../translations/generic.translations.js";
import { tw as r } from "../../utils/tailwind.js";
import { Decimal as S, MAX_SCORE as n } from "./Rating.constant.js";
const J = ["aria-label"], K = { class: "flex" }, le = /* @__PURE__ */ E({
  name: "RevRating",
  __name: "Rating",
  props: {
    score: {},
    showScoreLabel: { type: Boolean, default: !0 },
    totalReviews: { default: void 0 },
    size: { default: "medium" },
    ratingAriaLabel: { default: void 0 },
    to: { default: void 0 }
  },
  setup(h) {
    const e = h, w = X();
    P({
      "[Rating] invalid type: score must be a number": () => typeof e.score != "number",
      "[Rating] invalid score: expected number between 0 and 5": () => e.score < 0 || e.score > n,
      "[Rating] invalid ratingAriaLabel: is required when showScoreLabel is false": () => !e.showScoreLabel && !e.ratingAriaLabel
    });
    const d = a(() => {
      const t = {
        "extra-small": r`items-center`,
        small: r`items-center`,
        medium: r``
      };
      return [r`text-action-default-hi flex items-center`, t[e.size]];
    }), _ = a(() => ({
      "extra-small": r`caption-bold`,
      small: r`body-2-bold`,
      medium: r`heading-3`
    })[e.size]), R = a(() => ({
      "extra-small": r`caption-bold`,
      small: r`body-2-bold`,
      medium: r`heading-3`
    })[e.size]), f = a(() => {
      const t = Math.round(e.score * S.one) / S.one;
      return new Intl.NumberFormat(w.value).format(t);
    }), x = a(() => `${f.value}/${n}`), y = j(), z = e.ratingAriaLabel || y(G.rating, {
      rating: f.value,
      maxRating: n
    }), L = a(
      () => e.totalReviews && e.to && e.showScoreLabel
    );
    function N(t) {
      const o = Math.floor(t), s = Number.parseFloat(t.toFixed(1)) - o;
      return s < 0.3 - Number.EPSILON ? [o, !1] : s < 0.8 - Number.EPSILON ? [o + 1, !0] : [o + 1, !1];
    }
    const A = a(() => e.score < 0 || e.score > n), C = a(() => {
      const [t, o] = N(
        e.score
      ), l = n - t, s = Array.from(Array(t)).map((Q, $) => $ + 1 === t && o ? q : H);
      if (A.value) return [];
      const k = Array.from(Array(l)).map(() => W);
      return [...s, ...k];
    });
    return (t, o) => (i(), c("div", {
      class: m(d.value)
    }, [
      p("div", {
        "aria-label": u(z),
        class: m(d.value),
        role: "img"
      }, [
        p("div", K, [
          (i(!0), c(B, null, D(C.value, (l, s) => (i(), b(F(I(l)), {
            key: s,
            "aria-hidden": "true",
            size: u(V)[t.size]
          }, null, 8, ["size"]))), 128))
        ]),
        e.showScoreLabel ? (i(), c("span", {
          key: 0,
          "aria-hidden": "true",
          class: m(["ml-4 mt-1 md:mt-2", _.value])
        }, g(x.value), 3)) : v("", !0)
      ], 10, J),
      L.value ? (i(), b(u(O), {
        key: 0,
        class: m(["text-action-default-low ml-4 mt-1 md:mt-2", R.value]),
        to: e.to
      }, {
        default: M(() => [
          T(g(`(${e.totalReviews})`), 1)
        ]),
        _: 1
      }, 8, ["class", "to"])) : v("", !0)
    ], 2));
  }
});
export {
  le as default
};
